import { useQuery } from "react-query";
import { fetchWeissInsightsData } from "./api";

export function useWeissInsights(filters, options = {}) {
  return useQuery(
    ["fetchWeissInsightsData", filters],
    () => fetchWeissInsightsData(filters),
    {
      staleTime: 60000 * 600,
      cacheTime: 60000 * 6000,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
}
